import { render, staticRenderFns } from "./Collaborators.vue?vue&type=template&id=6ed4b2a9&scoped=true"
var script = {}
import style0 from "./Collaborators.vue?vue&type=style&index=0&id=6ed4b2a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed4b2a9",
  null
  
)

export default component.exports